export enum UserRoleEnum {
  MASTER = 'MASTER',
  NORMAL = 'NORMAL',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN'
}
